import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useResolvedFacility } from "@/hooks/use-selected-facility";

import { MembershipPlans } from "./membership-plans";

export function MembershipsPage() {
  const { facility, facilityId, isLoading } = useResolvedFacility();

  return (
    <Stack spacing={2.5} sx={{ px: { xs: 2, lg: 3 }, pb: 3 }}>
      <Box>
        <Typography component="h1" variant="h4" sx={{ fontWeight: 700 }}>
          Membership plans
        </Typography>
        <Typography color="text.secondary" variant="body2" sx={{ mt: 0.5 }}>
          {facility?.name ?? "Recurring plans and prepaid visit packs"}
        </Typography>
      </Box>

      {isLoading || !facilityId ? (
        <Stack
          aria-live="polite"
          direction="row"
          role="status"
          spacing={1}
          sx={{
            minHeight: 160,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={20} />
          <Typography color="text.secondary" variant="body2">
            Loading membership plans…
          </Typography>
        </Stack>
      ) : (
        <MembershipPlans key={facilityId} facilityId={facilityId} />
      )}
    </Stack>
  );
}
